import React, { useState, useContext, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import { MetaContext } from "../context";
import uniqid from "uniqid";
import { Product, CSSproduct, CSSproductAct } from "./Product";
import {
    Flex,
    Button,
    CSSmainLayout,
    Line,
    MobHide,
    MobShow,
    CSSpreloader,
    Preloader,
    Preloader0
} from './Uikit';

import { Appearer } from "./Appearer";

import { StackInfo } from "./StackInfo";
import { getDataById } from "./Utilities";
import { Header } from "./Header";
import { CatalogSection } from "./CatalogSection";

import { NavHashLink } from "react-router-hash-link";
import { Footer } from "./Footer";
import { Stack } from "./Stack";
import { FixedBottom } from "react-fixed-bottom";

export const Catalog = React.memo((props) => {
  const { history, match, location, stack } = {...props};
  const context = useContext(MetaContext);

  const [activeCats, setActiveCats] = useState([]);
  const [activeGoals, setActiveGoals] = useState([]);
  const [type, setType] = useState("goal"); //categories

  const [stackMode, setStackMode] = useState(stack);

  const [mainWidth, setMainWidth] = useState('100%');
  const [mainScroll, setMainScroll] = useState();

  const highLightSection = (id) => {
    setHighlighted(id);
  };

  const [highlighted, setHighlighted] = useState();

  const setTyp = (newType) => {
    setType(newType);
  };

  useEffect(() => {
    if (location && location.pathname.includes("stack") ||
        location && location.pathname.includes("quiz")) {
          // setMainWidth(`${mainConteyner.current.getBoundingClientRect().width}px`)
          console.log('window.innerWidth = ', window.innerWidth);
          setMainWidth(`${window.innerWidth}px`)
          // if (!mainScroll) setMainScroll(window.pageYOffset);
          setStackMode(true);
          // if (mainScroll) mainConteyner.current.scrollTop = mainScroll;
    } else {
      setMainWidth('100%');
      setStackMode(false);
      // debugger
      window.scrollTo(0, mainScroll);
      // if (mainScroll) mainConteyner.current.scrollTop = mainScroll;
      setMainScroll(false);
    }
  }, [history, location]);

  const mainConteyner = useRef();

  return (<>
    <CSScatalog width={mainWidth} stackMode={stackMode} ref={mainConteyner}>
      <Header handleCat={setTyp} active={type}
        // stackMode={stackMode}
        />

      {!Boolean(context['data']['categories'].length) && <Preloader0><Preloader width={80} height={80}/></Preloader0>}

      {Boolean(context['data']['categories'].length) && <CSSmainLayout
        style={{
          zIndex: 1,
          position: "relative",
        }}
      >
        <CSSmenu0 stackMode={stackMode}>
          <CSSmenu>
            <br />

            {context["data"][type].map((oneCat) => (
              <CSSnavHashLink
                key={`name-${oneCat["id"]}`}
                to={`/#${oneCat["name"]}`}
                scroll={(el) =>
                  el.scrollIntoView({ behavior: "smooth", block: "start" })
                }
                // activeClassName="selected"
                // activeStyle={{ background: 'white'}}
                active={highlighted === oneCat["name"] ? "highlighted" : null}
              >
                {oneCat["title"]}
              </CSSnavHashLink>
            ))}
          </CSSmenu>
        </CSSmenu0>

        <CSSitems stackMode={stackMode}>
          {context["data"][type].map((oneGoal, i) => {
            return (
              <CatalogSection
                first={!i ? true : false}
                highLightSection={highLightSection}
                key={`slider-${oneGoal["id"]}`}
                type={type}
                oneGoal={oneGoal}
              />
            );
          })}
        </CSSitems>

        <MobHide>
          <CSSright>
            <Stack
              stackMode={stackMode}
              handleShown={() => history.push("/")}
              history={history}
              match={match}
              location={location}
            />
          </CSSright>
        </MobHide>

        <MobShow>
          <FixedBottom
            style={{bottom: 'offset'}}
          >
            <CSSstackBottom
              stackShown={location.pathname.includes("stack") ? true : false}
              shown={context.handles.getStack().length ? true : false}
            >
              <Stack
                handleShown={() => history.push("/")}
                history={history}
                match={match}
                location={location}
              />
            </CSSstackBottom>
          </FixedBottom>
        </MobShow>
      </CSSmainLayout>
}
      <Footer />
    </CSScatalog>
  </>
  );
});

const CSScatalog = styled.div`
  width: ${({width})=> width ? width : '100%'};
  max-width: 100vw;
  position: relative;
  background: var(--main-bg-color);
  /* overflow-y: auto; */
  /* height: 100vh; */
  padding-bottom: 8em;
  ${({ stackMode }) => stackMode && css`
      overflow-x: hidden;
      overflow-y: hidden;
      height: 100vh;
      min-height: 100%;
      box-sizing: border-box;
      @media (max-width: 991px) {
        height: 90vh;
        overflow-y: hidden;
      }
    `}
`;

const CSSstackBottom = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0em;
  width: 100%;
  transition: transform 250ms ease-in-out;
  transform: translateY(80px);

  ${({ shown }) =>
    shown &&
    css`
      margin-bottom: 0px;
      transform: translateY(0px);
    `}
  ${({ stackShown }) =>
    stackShown && css`
      margin-bottom: 8px;
      top: 0;
      transform: translateY(0px);
    `}
`;

const CSSnavHashLink = styled(NavHashLink)`
  display: inline-block;
  margin-left: -1em;
  display: block;
  font-size: 0.9em;
  font-weight: 600;
  text-decoration: none;
  color: var(--main-text-lighter-color);
  padding: 1em;
  background: transparent;
  border-radius: var(--main-border-radius);
  margin-bottom: 1em;
  transition: background-color 150ms ease-in-out;
  cursor: pointer;
  &:hover {
    background: rgb(255, 254, 248);
  }
  ${({ active }) =>
    active &&
    css`
      color: var(--main-text-color);
      box-shadow: 0px 5px 12px -3px rgba(106, 96, 96, 0.05),
        0px 7px 60px -16px rgba(106, 96, 96, 0.1);
      background: #ffffff;
    `}
`;

const CSSmenu0 = styled.div`
  transition: all 50ms ease-in-out;
  position: relative;
  @media (max-width: 991px) {
    display: none;
  }
  /* ${({ stackMode }) =>
    stackMode &&
    css`
      transform: translateX(-20px);
      opacity: 0;
    `} */
`;

const CSSitems = styled.div`
  transition: all 100ms ease-in-out;
  color: var(--main-text-color);
  position: relative;
  /* ${({ stackMode }) =>
    stackMode &&
    css`
      transform: translateX(-30px);
    `} */
`;



export const CSSgrid = styled.div`
  display: grid;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: start;
  grid-column-gap: 0.4em;
  grid-row-gap: 0.4em;
  grid-template-rows: auto;
  grid-template-columns: ${({ width }) =>
    width
      ? `repeat(auto-fit, minmax(${width}px, ${width}px))`
      : `repeat(auto-fit, minmax(220px, 238px))`};
  @media (max-width: 991px) {
    grid-template-columns: ${({ width }) =>
      width
        ? `repeat(auto-fit, minmax(140px, 1fr))`
        : `repeat(auto-fit, minmax(140px, 48%))`};
  }
`;

const CSSmenu = styled.div`
  position: sticky;
  padding-top: 1em;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  top: 2em;
`;

const CSSright = styled.div`
  position: sticky;
  top: 2em;
`;

const CSSsm = styled.div`
  font-size: 0.8em;
`;

